import { GridColDef } from '@mui/x-data-grid-premium';
import React, { useEffect, useMemo } from 'react';
import { tableSettingsProps, useTableSettings } from '../tableSettings/useTableSettings';
import tableHelper from 'src/utils/tableHelper';
import { useGetFullfillmentOrderRows, useGetFullfillmentOrders, } from '../../api/requestConfigs/warehouse';


export const useFullfillmentOrdersTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const {rows,status} = useGetFullfillmentOrders();
  //console.log(rows);
  const idPath = ["Id"];
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'Id', headerName: 'Id', },
      { field: 'Status_Value', headerName: 'Status', valueGetter: tableHelper.getFieldKeyOrValue, renderCell: tableHelper.renderStatusCell, },
      { field: 'CustomerName', headerName: 'Customer Name', width: 220 },
      { field: 'FulfillmentStrategy_Value', headerName: 'Fulfillment Strategy', valueGetter: tableHelper.getFieldKeyOrValue, width: 280 },

      { field: 'Priority_Value', headerName: 'Priority', valueGetter: tableHelper.getFieldKeyOrValue, },
      { field: 'SelectedWarehouse', headerName: 'Selected Warehouse', width: 200 },
      { field: 'DateCreated', headerName: 'Date Created', type: 'dateTime', valueGetter: tableHelper.getDateColumn, },
      { field: 'DateFulfilled', headerName: 'Date Fulfilled', type: 'dateTime', valueGetter: tableHelper.getDateColumn, },
      { field: 'DeliveryAddress', headerName: 'Delivery Address', },
      { field: 'DispatchCommands', headerName: 'Dispatch Commands', },
      { field: 'ExternalCustomerId', headerName: 'External Customer Id', },
      { field: 'ExternalCustomerOrderRef', headerName: 'External Customer Order Ref', },
      { field: 'HasDispatchCommandsInStatusCreated', headerName: 'Has Dispatch Commands In Status Created', },
      { field: 'RequiredWarehouse', headerName: 'Required Warehouse', },
      { field: 'RequiresSingleDelivery', headerName: 'Requires Single Delivery', },

    ],
    [],
  );
  const tableName = "FullfillmentOrdersTable";
  const tableSettings = useTableSettings({ columns, idPath, rows, tableName,status });
  useEffect(() => {
    tableSettings.setColumnVisibilityModel({
      ExternalCustomerId: false,
      HasDispatchCommandsInStatusCreated: false,
    });
  }, []);
  
  return [columns, tableSettings];
};




export const useFullfillmentOrderRowsTable = (
  id, dependency: any = null
): [columns: GridColDef[], tableSettings: tableSettingsProps, createdDispatchCommandId?: number] => {
  const fullRows = useGetFullfillmentOrderRows(id, dependency);
  //console.log(fullRows);

  const createdDispatchCommand = useMemo(
    () =>
      fullRows?.DispatchCommands?.find(
        (cmd) => cmd.Status?.Value?.toLowerCase() === 'created'
      ),
    [fullRows]
  );
  const createdDispatchCommandId = createdDispatchCommand?.Id;

  const rows = useMemo(() => {
    const dispatchRows = createdDispatchCommand?.DispatchCommandRows || [];
    return fullRows?.FulfillmentOrderRows?.map((row) => {
      const isReady = dispatchRows.some(
        (d) => d.ArticleNumber === row.ProductId
      );
      let statusText = '';
      if (isReady) {
        statusText = 'Ready For Dispatch';
      } else if (row.QtyFulfilled === row.QtyOrdered) {
        statusText = 'Completed';
      } else if (row.QtyDispatching === row.QtyOrdered) {
        statusText = 'Dispatching';
      } else if (row.QtyRequested > 0) {
        statusText = 'Requested';
      }
      return {
        ...row,
        Status: statusText,
      };
    });
  }, [fullRows, createdDispatchCommand]);

  const idPath = ['RowNr'];

  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'RowNr', headerName: 'Row', width: 50 },
      { field: 'Status', headerName: 'Status',  width: 140,renderCell: tableHelper.renderStatusCell},
      { field: 'ProductId', headerName: 'Product Id', width: 100 },
      { field: 'ManufacturerProductId', headerName: 'Manufacturer Product Id' },
      { field: 'Product', headerName: 'Product', width: 250 },
      { field: 'QtyToFulfill', headerName: 'Qty To Fulfill', type: 'number' },
      { field: 'QtyReserved', headerName: 'Qty Reserved', type: 'number' },
      { field: 'QtyRequested', headerName: 'Qty Requested', type: 'number' },
      { field: 'QtyDispatching', headerName: 'Qty Dispatching', type: 'number' },
      { field: 'QtyFulfilled', headerName: 'Qty Fulfilled', type: 'number' },
      { field: 'QtyOrdered', headerName: 'Qty Ordered', type: 'number' },
    ],
    []
  );

  const tableName = 'FullfillmentOrderRowsTable';
  const tableSettings = useTableSettings({ columns, idPath, rows, tableName});

  tableSettings.hasToolbar = false;
  tableSettings.autoHeight = true;
  tableSettings.loading = false;
  tableSettings.hideFooter = true;

  return [columns, tableSettings, createdDispatchCommandId];
};

